import _ from 'lodash';
import {getDefaultPieFormatting} from '@/containers/E4ImpactMBA/charts/pie';
import {COLORS} from '@/utils/constants';
import {getSubmissions} from '@/containers/E4ImpactProjects/TabSections/Output/filterByEmployees';

/**
 * Survey: PROJECT - BASELINE IMPACT
 * Question: How many employees are on ... ?
 * 
 * == baseline
 * question69_item_1_number - Permanent contracts
 * question69_item_2_number - Fix-term contracts
 * question69_total_number - Total employees
 * 
 * Survey: PROJECT- FINAL IMPACT
 * Question: How many employees are on ... ?
 * 
 * == final
 * question13_item_1_number - Permanent contracts
 * question13_item_2_number - Fix-term contracts
 * question13_total_number - Total employees
 * 
 * @param props 
 * @returns 
 */
export const newJobsByTypeOfContractsChartCalculation = (props: any) => {
    const positiveSubmissions = getSubmissions(props);

    const filteredFinal = Object.values(positiveSubmissions).map(({finalSubmission}) => finalSubmission);
    const filteredBaseline = Object.values(positiveSubmissions).map(({baselineSubmission}) => baselineSubmission);
    
    const fullTimeContracts = _.sumBy(filteredFinal, 'question13_item_1_number') - _.sumBy(filteredBaseline, 'question69_item_1_number');
    const partTimeContracts = _.sumBy(filteredFinal, 'question13_item_2_number') - _.sumBy(filteredBaseline, 'question69_item_2_number')

    const data = [
        {
            name: 'Full-time contracts',
            color: COLORS.e4ImpactBlue,
            y: fullTimeContracts
        },
        {
            name: 'Part-time contracts',
            color: COLORS.e4ImpactOrange,
            y: partTimeContracts
        },
    ];
    
    return getDefaultPieFormatting(
        'KPI: New jobs by type of contracts',
        data
    ) as Highcharts.Options;
}